// Maps backend error keys to frontend form field names
export const ERROR_FIELD_MAP: Record<string, string> = {
  MISCELLANEOUS_ERROR: "globalError",
  APPLICTN_TYPE: "applType",
  TERM_BEGIN_DATE: "termBegin",
  TERM_END_DATE: "termEnd",
  COURSE_START_DATE: "courseStartDate",
  COURSE_END_DATE: "courseEndDate",
  COURSE_NAME: "courseName",
  DEGREE_COMPLETION_YEAR_CLASS_INFO: "degreeCompletionYear",
  SCHOOL_NAME_UNDER_CLASS_INFO: "classSchoolName",
  SCHOOL_NAME_UNDER_PROGRAM_INFO: "schoolName",
  DEGREE_NAME_UNDER_PROGRAM_INFO: "degreeName",
  APPLICATION_YEAR: "applicationYear",
  APPLICATION_DATE: "applDate",
  COURSE_CREDIT: "courseCredit",
  REIMBURSEMENT_TYPE: "reimbursementType",
  PROG_TYPE_UNDER_PROGRAM_INFO: "programType",
  PROG_TYPE_UNDER_CLASS_INFO: "courseProgramType",
  WAIT_PERIOD: "globalError",
  BALANCE_ERROR: "globalError",
  COURSE_DELIVERY_TYPE: "courseDeliveryType",
  TRAVEL_DATES: "travelDates",
  FUNDING_SOURCE: "fundingSource",
  APPLICATION_STATUS: "applStatus",
  PROGRAM_FIELD: "programField",
  EMPLOYEE_ID: "empId",
  APPLICATION_TERM: "applicationTerm",
  TERM_YEAR: "applicationYear",
  DUPLICATE_RECORD: "globalError",
};
